/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&name=PhoneFooter&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=PhoneFooter&lang=js"

import "./index.vue?vue&type=style&index=0&id=487b9e98&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-487b9e98"]])

export default __exports__